<template>
  <div class="wrapper">
    <div v-if="isOpen" class="categories">
      <div class="topic-section">
        <div
          v-for="(topic, index) in categories"
          :key="topic.id"
          v-track-click="{
            name: BTN_EVTS.CHAT_ROOM_FLOATING_HAMBURGER_OPTION_SELECTED,
            selection: topic.id,
          }"
          :class="[
            'topic',
            {
              border__bottom: index <= borderLine,
              border__right: index % 3 !== 2 && index !== categories.length - 1,
            },
          ]"
          @click="onSelectCategory(topic)"
        >
          <img
            :src="
              topic.iconUri ||
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='
            "
          />
          <div>
            <span>{{ topic.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-track-click="{
        name: BTN_EVTS.CHAT_ROOM_FLOATING_HAMBURGER_CLICK,
        metadata: { open: !isOpen },
      }"
      class="float"
      @click="toggleMenu"
    >
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator';
import { SystemListMessage, SystemOption, SystemOptionEvent } from '@/common/bot/types';
import { SystemEvent } from '@/common/bot/enum';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

@Component({
  directives: {
    trackClick,
  },
})
export default class FloatButton extends Vue {
  @Prop({ default: () => ({}) }) readonly categoryMessage!: SystemListMessage;

  readonly BTN_EVTS = BTN_EVTS;

  isOpen = false;

  get categories() {
    return this.categoryMessage?.options || [];
  }

  get borderLine() {
    const remainder = this.categories.length % 3;
    if (remainder === 0) return this.categories.length - 3 - 1;
    const indexNeedLine = this.categories.length - (this.categories.length % 3) - 1;
    return indexNeedLine;
  }

  onSelectCategory(selected: SystemOption) {
    this.$emit('message:input', {
      type: SystemEvent.LIST_OPTION_SELECTED,
      message: this.categoryMessage,
      payload: { selected },
    } as SystemOptionEvent);
    this.toggleMenu();
  }

  toggleMenu() {
    if (!this.categories.length) return;
    this.isOpen = !this.isOpen;
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variable.scss';
.wrapper {
  position: relative;
  .categories {
    position: absolute;
    background-color: $inner-float-button-panel-background;
    bottom: 6.8rem;
    box-shadow: 0 -0.3rem 0.5rem 0 rgba(0, 0, 0, 0.1);
    width: 100%;
    .topic-section {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      padding: 1rem 0.5rem;
      .topic {
        flex-basis: 32%;
        padding-top: 0.8rem;
        padding-bottom: 1.2rem;
        color: $inner-float-button-panel-text-color;
        font-size: 1.4rem;
        text-align: center;
        margin: 0.4rem 0.2rem;
        align-items: center;
        cursor: pointer;
        position: relative;
        &.border {
          &__right {
            &:before {
              content: '';
              position: absolute;
              top: calc((100% - 3.3rem) / 2);
              right: 0;
              height: 3.3rem;
              width: 0.1rem;
              background-color: $inner-float-button-panel-border-color;
            }
          }
          &__bottom {
            &:after {
              content: '';
              position: absolute;
              top: auto;
              bottom: 0;
              left: calc((100% - 4.2rem) / 2);
              right: auto;
              height: 0.1rem;
              width: 4.2rem;
              background-color: $inner-float-button-panel-border-color;
            }
          }
        }
        img {
          height: 3rem;
          padding-top: 0.2rem;
        }
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
  .float {
    position: absolute;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 100%;
    background-color: $inner-float-button-background;
    bottom: 2rem;
    left: 2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    padding: 1rem 0;
    cursor: pointer;
    div {
      border-bottom: 0.25rem solid $inner-float-button-text-color;
      width: 1.8rem;
    }
  }
}
</style>
